import React, {Component} from 'react';
import { connect } from 'react-redux';
// Components
import Footer from 'components/presentational/Footer';
import ReplaySection from 'components/presentational/ReplaySection';
import ClaimProcessSVG from 'components/svg/ClaimProcessSVG.js';
import GTMPush from 'components/GTMPush'
// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js';
// Files
import './claim-process.scss'

const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedClaimProcess extends Component {
    constructor() {
        super();
        this.image = React.createRef();
        this.audio = React.createRef();

        // Bindigs
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        this.props.setAudioToPlay('ClaimProcess');
        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio);
    }

    handleReplayClick() {
        this.animateSection();
    }

    render() {
        return (
            <div className="claim-process">
            
                <GTMPush 
                  event="pageLoad" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="02" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                
                <div className="container">
                    <div className="row">
                        <div className="col-one-half">
                            <h1 className="claim-process__heading heading-1">Step 1: Start the beneficiary claim process</h1>

                            <div className="claim-process__content">
                                <p>First, you’ll need to fill out the claim form that came in your beneficiary claim kit or complete online. It covers basic identifying information.</p>

                                <ul className="list">
                                    <li><strong>Name</strong></li>

                                    <li><strong>Address</strong></li>

                                    <li><strong>Phone number</strong></li>
                                </ul>

                                <p>You’ll also need to provide similar info about the deceased as well as their SSN.  You’ll find the claim form in your kit or complete online.</p>
                            </div>
                        </div>

                        <div className="col-one-half">
                            <div className="claim-process__image">
                                <ClaimProcessSVG  ref={this.image}  className="image" />
                            </div>
                            
                        </div>
                    </div>
                    
                    <ReplaySection handleClick={this.handleReplayClick}/>
                </div>

                <Footer pageIndex={2}/>
            </div>
        )
    }
}

const ClaimProcess = connect(mapStateToProps, mapDispatchToProps)(ConnectedClaimProcess);

export default ClaimProcess
